import { Box, Button, Container, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Header from '../Components/Header'
import bgImage from "../Images/Featureshero1.jfif";
import icall4 from "../Images/about1.png"
import { Link } from 'react-router-dom';
import Footer from '../Components/Footer';
import Upbutton from '../upbutton/Upbutton';
import Aos from "aos";
import "aos/dist/aos.css";
import axios from 'axios';
import { Helmet } from 'react-helmet';
import Loader from '../Loader/Loader';

const About = () => {
    const [data, setData] = useState(null);
    const [store, setStore] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        Aos.init({
            duration: 1000,
            easing: "ease-in-out",
            once: true,
        });
        const timer = setTimeout(() => {
            setLoading(false);
        }, 3000);
        return () => clearTimeout(timer);
    }, []);
    const token = "cowberryapps.icallphonedialer.contactbook";
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`http://localhost:5000/scrape/modal?url=https://play.google.com/store/apps/details?id=${token}`);
                const response1 = await axios.get(`http://localhost:5000/scrape?url=https://play.google.com/store/apps/details?id=${token}`);
                console.log('Full Response:', response.data);
                setData(response.data);
                setStore(response1.data)
                setLoading(false);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, []);

    const infoItems = [
        { label: "Version", value: data?.version || "1.17" },
        { label: "Updated on", value: data?.updatedDate || "11 Apr 2025" },
        { label: "Rating", value: (store?.rating?.slice(0, 3) || "3.9") + " ⭐" },
        { label: "Reviews", value: store?.reviews || "500+ reviews" },
        { label: "Requires Android", value: data?.requiresAndroid || "6.0 and up" },
        { label: "Downloads", value: data?.downloads || "100,000+ downloads" },
        {
            label: "Content rating",
            value: (
                <>
                    {data?.contentRating.slice(0, 13) || "Rated for 3+"}{" "}
                    <Link to="https://play.google.com/store/apps/details?id=cowberryapps.icallphonedialer.contactbook"
                        style={{ textDecoration: 'none' }}
                        target="_blank"
                        rel="noopener"
                        sx={{ color: '#01875f' }}
                    >
                        Learn more
                    </Link>
                </>
            ),
        },
        {
            label: "Permissions",
            value: (
                <Link
                    to="https://play.google.com/store/apps/details?id=cowberryapps.icallphonedialer.contactbook"
                    style={{ textDecoration: 'none' }}
                    target="_blank"
                    rel="noopener"
                    sx={{ color: '#01875f' }}
                >
                    View details
                </Link>
            ),
        },
        { label: "Released on", value: data?.releasedOn || "18 Oct 2024" },
        { label: "Offered by", value: data?.offeredBy || "Cowberry Apps LLP" },
    ];

    if (loading) {
        return (
            <div className="App">
                <Loader />
            </div>
        );
    }
    return (
        <Box>
            <Helmet>
                <title>About - iCall Phone Dialer & Contacts</title>
            </Helmet>
            {/* ========= header ======= */}
            <Box>
                <Header />
            </Box>
            <Box sx={{ height: { xs: '56px', sm: '70px' } }} />
            {/* ======= hero sections ======= */}
            <Box sx={{
                backgroundImage: `url(${bgImage})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                // minHeight: '100vh',
                height: { md: '400px', xs: "300px" },
                display: 'flex',
                alignItems: 'center',
            }}>
                <Box sx={{
                    width: '100%',
                    height: '100%',
                    bgcolor: 'rgba(0, 0, 0, 0.6)',
                    display: 'flex',
                    alignItems: 'center',
                }}>
                    <Container maxWidth="xl">
                        <Box>
                            <Typography
                                variant="h4"
                                sx={{
                                    color: '#fff',
                                    textAlign: 'center',
                                    fontWeight: 700,
                                    // fontFamily: '"Google Sans", "Roboto", "Arial", sans-serif',
                                    fontSize: { md: '34px', sm: '30px', xs: '24px' }
                                }}
                            >
                                App Information
                            </Typography>
                            <Typography variant='h6' sx={{ textAlign: 'center', marginTop: '10px' }}>
                                <Link to={"/"} style={{ textDecoration: 'none', color: '#fff' }}> Home /</Link> <span style={{ fontWeight: '700', color: "rgb(64, 153, 247)" }}> About</span>
                            </Typography>
                        </Box>
                    </Container>
                </Box>
            </Box>
            {/* ===== imge sections ==== */}
            <Box data-aos="fade-up" sx={{
                paddingTop: { md: '100px', sm: '60px', xs: '30px' },
            }}>
                <Container maxWidth="xl">
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '20px',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }}
                    >
                        {/* Image Section */}
                        <Box
                            sx={{
                                width: { xs: '100%', md: 'calc(50% - 10px)' },
                                display: 'flex',
                                justifyContent: 'center',
                            }}
                        >
                            <Box className='imageanimations' sx={{ width: '65%' }}>
                                <img
                                    src={icall4}
                                    alt="iCall App Preview"
                                    style={{ width: '100%', maxWidth: '400px', height: 'auto', display: 'block', margin: '0px auto' }}
                                />
                            </Box>
                        </Box>

                        {/* Text Section */}
                        <Box sx={{ width: { xs: '100%', md: 'calc(50% - 10px)' } }}>
                            <Typography
                                className='sectionheading'
                                variant="h4"
                                sx={{ fontSize: { md: '40px', sm: '30px', xs: '24px' } }}
                            >
                                iCall Phone Dialer & Contacts
                            </Typography>

                            <Typography
                                className='sectiondescption'
                                variant="body1"
                                sx={{
                                    marginTop: '16px',
                                    textAlign: 'justify',
                                }}
                            >
                                iCall Phone Dialer & Contacts application has unique feature to manage contacts in same iOS style themes.
                                Find here amazing dialer pad to dial contacts, show call logs with all calls and missed calls, favorite contacts.
                                Apply filter for calls as easy view for recent calls and missed calls only.
                                <br /><br />
                                Our app is designed for a seamless user experience with a simple,
                                intuitive interface. We value your privacy — your data is never collected
                                or stored.
                            </Typography>
                        </Box>
                    </Box>
                </Container>
            </Box>
            {/* ====== about feature ===== */}
            <Box data-aos="fade-up" sx={{ marginTop: { md: '100px', sm: '60px', xs: '30px' } }}>
                <Container maxWidth="xl">
                    <Box sx={{ width: '100%', display: 'flex', flexWrap: 'wrap', gap: '40px' }}>
                        <Box sx={{ width: { md: 'calc(50% - 20px)', xs: '100%' } }}>
                            <Typography
                                variant="h4"
                                sx={{
                                    color: '#212121d4 ',
                                    textAlign: { sm: 'start', xs: 'center' },
                                    fontWeight: 700,
                                    // fontFamily: '"Google Sans", "Roboto", "Arial", sans-serif',
                                    fontSize: { md: '24px', xs: '20px' },
                                }}
                            >
                                Features Information
                            </Typography>
                            <Box
                                className='descption'
                                sx={{
                                    width: '100%',
                                    marginTop: { md: '50px', xs: '30px' },
                                    textAlign: 'justify'
                                }}
                            >
                                <Typography variant="body1" sx={{ mb: 1 }}>
                                    * iCall phone dialer to dial any contacts in iOS style dialer pad.
                                </Typography>
                                <Typography variant="body1" sx={{ mb: 1 }}>
                                    * A beautiful iOS style caller screen for incoming and outgoing calls.
                                </Typography>
                                <Typography variant="body1" sx={{ mb: 1 }}>
                                    * Amazing HD background and animated GIF collection that helps to set over caller screen.
                                </Typography>
                                <Typography variant="body1" sx={{ mb: 1 }}>
                                    * Set accept and decline buttons from the collection.
                                </Typography>
                                <Typography variant="body1" sx={{ mb: 1 }}>
                                    * Show contact view with a list of all contacts saved in your phone.
                                </Typography>
                                <Typography variant="body1" sx={{ mb: 1 }}>
                                    * Now make a call from the favorite contact or call log screen.
                                </Typography>
                                <Typography variant="body1" sx={{ mb: 1 }}>
                                    * Easily call on any numbers with dial pad to show customize caller screen.
                                </Typography>
                                <Typography variant="body1" sx={{ mb: 1 }}>
                                    * You can block unwanted incoming phone calls and spam calls to show blocked number list.
                                </Typography>
                                <Typography variant="body1" sx={{ mb: 1 }}>
                                    * Stay informed without ever looking at your phone. iCall Phone Dialer announces the caller’s name or number, perfect for when you’re driving or engaged in activities.
                                </Typography>
                                <Typography variant="body1" sx={{ mb: 1 }}>
                                    * Easily User can swap answer or decline button in customize caller screen.
                                </Typography>
                                <Typography variant="body1" sx={{ mb: 1 }}>
                                    * Now feel "Slide To Answer" experience on "slide to answer" button like on iOS style.
                                </Typography>
                            </Box>
                        </Box>
                        <Box sx={{ width: { md: 'calc(50% - 20px)', xs: '100%' } }}>
                            <Typography
                                variant="h4"
                                sx={{
                                    color: '#212121d4 ',
                                    fontWeight: 700,
                                    // fontFamily: '"Google Sans", "Roboto", "Arial", sans-serif',
                                    fontSize: { md: '24px', xs: '20px' },
                                    textAlign: { sm: 'start', xs: 'center' }
                                }}
                            >
                                App Information
                            </Typography>

                            <Box sx={{ width: "100%" }}>
                                <Box
                                    sx={{
                                        width: "100%",
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: "40px",
                                        marginTop: { md: '50px', xs: '30px' },
                                    }}
                                >
                                    {infoItems.map((item, index) => (
                                        <Box
                                            key={index}
                                            sx={{
                                                width: {
                                                    md: "calc(50% - 20px)",
                                                    sm: "calc(50% - 20px)",
                                                    xs: "100%",
                                                },
                                                textAlign: { sm: 'start', xs: 'center' }
                                            }}
                                        >
                                            <Typography variant="h6" sx={{ color: '#212121d4', fontWeight: 500 }}>
                                                {item.label}
                                            </Typography>
                                            <Typography variant="body1" sx={{ color: '#757575' }}>
                                                {item.value}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Box>
                            </Box>

                        </Box>
                    </Box>
                </Container>
            </Box>
            {/* ======= App using sections ====== */}
            <Box data-aos="fade-up" sx={{ marginTop: { md: '100px', sm: '60px', xs: '30px' } }}>
                <Container maxWidth="xl">
                    <Box >
                        <Typography
                            variant="h4"
                            sx={{
                                color: '#212121d4 ',
                                textAlign: { sm: 'start', xs: 'center' },
                                fontWeight: 700,
                                fontSize: { md: '24px', xs: '20px' },
                            }}
                        >
                            Permissions Used For Core Functionality In App
                        </Typography>
                        <Typography
                            className='descption'
                            variant="body1"
                            sx={{
                                mt: 2,
                            }}>
                            Contacts permission used to display contacts to user.
                        </Typography>
                        <Typography className='descption' variant="body1">
                            Call Log permission used to show the recent call with missed calls history as call logs of the user in app.
                        </Typography>
                        <Typography className='descption' variant="body1">
                            Default Phone Dialer permission used to fetch the caller name and contact number of the user to display on screen.
                        </Typography>
                        <Typography className='descption' variant="body1">
                            App doesn't collect or store any of user contacts anywhere.
                        </Typography>
                    </Box>
                </Container>
            </Box>
            {/* ======== footer ===== */}
            <Box sx={{ marginTop: { md: '100px', sm: '60px', xs: '30px' } }}>
                <Footer />
            </Box>
            {/* ====== up button ===== */}
            <Box>
                <Upbutton />
            </Box>
        </Box>
    )
}
export default About